import { Button, Icon, Popover } from '@patternfly/react-core'
import {
  ExclamationCircleIcon,
  ExclamationTriangleIcon,
  InfoCircleIcon,
} from '@patternfly/react-icons'
import * as React from 'react'
import { useCallback, useState } from 'react'

import { TransmissionStatusId } from '@app/domain/interaction/interaction.interface'
import type { IProgramInteractionRecord } from '@app/domain/program/program.interface'
import { ProgramInteractionTypeId } from '@app/domain/program/program.interface'

interface Props {
  programInteraction: IProgramInteractionRecord
}

export const DisplayColumn = ({ programInteraction }: Props) => {
  const [
    unableToUpdatePopoverVisible,
    setUnableToUpdatePopoverVisible,
  ] = useState(false)

  const toggleUnableToUpdatePopover = useCallback(() => {
    setUnableToUpdatePopoverVisible((prev) => !prev)
  }, [])

  const failedDelivery = () => {
    return (
      <>
        <Icon status="danger">
          <ExclamationCircleIcon />
        </Icon>{' '}
        <span>Failed</span>
      </>
    )
  }

  const unableToUpdate = useCallback(() => {
    return (
      <>
        <Icon status="warning">
          <ExclamationTriangleIcon />
        </Icon>{' '}
        Unable to Update
        <Popover
          aria-label="Email consent information"
          bodyContent={'Destination is Read-Only'}
          isVisible={unableToUpdatePopoverVisible}
          hasAutoWidth
          shouldClose={toggleUnableToUpdatePopover}
        >
          <Button
            variant="plain"
            aria-label="Email consent info"
            onClick={toggleUnableToUpdatePopover}
            style={{ marginLeft: '0.5rem', padding: '0' }}
          >
            <InfoCircleIcon />
          </Button>
        </Popover>
      </>
    )
  }, [toggleUnableToUpdatePopover, unableToUpdatePopoverVisible])

  const delivered = () => {
    return <div style={{ color: 'green' }}>Delivered</div>
  }

  if (
    programInteraction.interaction.interactionType ===
    ProgramInteractionTypeId.RemoteInteraction
  ) {
    if (
      programInteraction.transmissionStatus === TransmissionStatusId.Failure
    ) {
      return failedDelivery()
    } else if (
      programInteraction.transmissionStatus ===
      TransmissionStatusId.InvalidState
    ) {
      return unableToUpdate()
    } else if (
      programInteraction.transmissionStatus === TransmissionStatusId.Success
    ) {
      return delivered()
    } else {
      return null
    }
  } else {
    return null
  }
}
